import { Checkbox } from "@material-ui/core"

import { SignatureForTable } from "../../DynamicFieldComponent/uploads/Signature/SignatureForTable"
import { useDispatch } from "react-redux"
import { setRowsForTableConstructor } from "../../../redux/reducers/act-reducer"
import { DynamicFields } from "../../../utils/dynamicFields"
import { MultilineTextFieldTable } from "./TableField/MultilineTextFieldTable"
import { TimeTable } from "../../DynamicFieldComponent/tables/TimeTable/TimeTable"
import { RenderViolationsCell } from "../../ActTable/ActTable"

import { DateTimeTable } from "../../DynamicFieldComponent/tables/DateTime"
import { AutocompleteSelectTable } from "../../DynamicFieldComponent/tables/AutocompleteSelect/AutocompleteSelectTable"


export const deleteIdTable = (stroke) => {
    const newStroke = stroke?.map((el) => {
        let newEl = {...el}
        delete newEl.id
        return newEl
    })
    return newStroke
}

export const mutateHead = (headName, headVariable) => {
    const newHeader = headName?.map((el, index) => {
        return {
            label: el, 
            key: headVariable[index + 1].field,
        }

    })
    return newHeader
}

const HandleRowChangeCheckBox = (params, values, setValues) => {

    let getRows = JSON.parse(JSON.stringify(values))
    if (getRows.length !== 0) {
        let newRows = []
        getRows.map(row => {
            if (row.id === params.id) {
                let newRow = row
                newRow[params.field] = !params.value
                newRows.push(newRow)
            } else newRows.push(row)
        })
        
        setValues(newRows)
    }  
}

export const howColumn = (el,  values, setValues, widthFieldXs) => {

    const width = widthFieldXs && widthFieldXs < 100 ? 100 : widthFieldXs;
    switch (el.type) {
        case DynamicFields.BASE_SELECT: 
            return (
                {     
                    field: el.variable, 
                    headerName: el.label, 
                    width: width,
                    editable: true,
                    content: el.content,
                    helperText: el.helperText,
                    id: el.id,
                    label: el.label,
                    sequenceNumber: el.sequenceNumber,
                    variable: el.variable,
                    type: "singleSelect",
                    valueOptions: el.content.choices.map(choice => choice.value),
                    typePole: el.type
                }
            )
        case DynamicFields.AUTOCOMPLETE_SELECT: 
            return (
                {     
                    field: el.variable, 
                    headerName: el.label, 
                    width: width,
                    editable: true,
                    content: el.content,
                    helperText: el.helperText,
                    id: el.id,
                    label: el.label,
                    sequenceNumber: el.sequenceNumber,
                    variable: el.variable,
                    type: "singleSelect",
                    valueOptions: el.content.choices.map(choice => choice.value),
                    typePole: el.type,
                    renderCell: (params) => ( <AutocompleteSelectTable {...params} values={values} setValues={setValues} />)
                }
            )
        case DynamicFields.CHECKBOX_FIELD: 
            return (
                {     
                    field: el.variable, 
                    headerName: el.label, 
                    width: width,
                    editable: false,
                    content: el.content,
                    helperText: el.helperText,
                    id: el.id,
                    label: el.label,
                    sequenceNumber: el.sequenceNumber,
                    variable: el.variable,
                    renderCell: (params) => (
                        <Checkbox checked={params.value} onClick={() => HandleRowChangeCheckBox(params, values, setValues)} />
                    ),
                    typePole: el.type
                }
            )
        case DynamicFields.NUMBER_FIELD: 
            return (
                {     
                    field: el.variable, 
                    headerName: el.label, 
                    width: width,
                    editable: true,
                    content: el.content,
                    helperText: el.helperText,
                    id: el.id,
                    label: el.label,
                    sequenceNumber: el.sequenceNumber,
                    variable: el.variable,
                    type: 'number',
                    typePole: el.type,
                }
            )    
        case DynamicFields.DATE_TIME_SELECT: 
            return (
                {     
                    field: el.variable, 
                    headerName: el.label, 
                    width: width,
                    editable: true,
                    content: el.content,
                    helperText: el.helperText,
                    id: el.id,
                    label: el.label,
                    sequenceNumber: el.sequenceNumber,
                    variable: el.variable,
                    type: 'dateTime',
                    typePole: el.type,
                    
                }
            ) 
        case DynamicFields.TABLE_DATE: 
            return (
                {     
                    field: el.variable, 
                    headerName: el.label, 
                    width: width,
                    content: el.content,
                    helperText: el.helperText,
                    id: el.id,
                    label: el.label,
                    sequenceNumber: el.sequenceNumber,
                    variable: el.variable,
                    typePole: el.type,
                    renderCell:(params) => (<DateTimeTable {...params} values={values} setValues={setValues} />),
                }
                
            ) 
        case DynamicFields.TABLE_DATE_TIME: 
            return (
                {     
                    field: el.variable, 
                    headerName: el.label, 
                    width: width,
                    editable: true,
                    content: el.content,
                    helperText: el.helperText,
                    id: el.id,
                    label: el.label,
                    sequenceNumber: el.sequenceNumber,
                    variable: el.variable,
                    type: 'dateTime',
                    typePole: el.type,
                }
            )
        case DynamicFields.TABLE_TIME: 
            return (
                {     
                    field: el.variable, 
                    headerName: el.label, 
                    width: width,
                    editable: false,
                    content: el.content,
                    helperText: el.helperText,
                    id: el.id,
                    label: el.label,
                    sequenceNumber: el.sequenceNumber,
                    variable: el.variable,
                    renderCell:(params) => (<TimeTable {...params} values={values} setValues={setValues} />),
                    typePole: el.type
                }
            )  
        case DynamicFields.SIGNATURE_FOR_TABLE: 
            return (
                {     
                    field: el.variable, 
                    headerName: el.label, 
                    width: width,
                    editable: false,
                    content: el.content,
                    helperText: el.helperText,
                    id: el.id,
                    label: el.label,
                    sequenceNumber: el.sequenceNumber,
                    variable: el.variable,
                    renderCell: (params) => (
                            <SignatureForTable 
                                idSignature={params.value} 
                                allParams={params}
                                setValues={setValues}
                                values={values}
                            />
                    ),
                    typePole: el.type
                }
            ) 
        case DynamicFields.TABLE_MULTILINE: 
            return (
                {     
                    field: el.variable, 
                    headerName: el.label, 
                    width: width,
                    editable: true,
                    content: el.content,
                    helperText: el.helperText,
                    id: el.id,
                    label: el.label,
                    sequenceNumber: el.sequenceNumber,
                    variable: el.variable,
                    renderEditCell: (params) => (
                            <MultilineTextFieldTable {...params} />
                    ),
                    type: 'string',
                    typePole: el.type,
                }
            ) 
        default: 
            return (
                {
                    field: el.variable, 
                    headerName: el.label, 
                    width: width,
                    editable: true,
                    helperText: el.helperText,
                    id: el.id,
                    label: el.label,
                    sequenceNumber: el.sequenceNumber,
                    variable: el.variable,
                    typePole: el.type,
                    renderCell: (params) => (
                        <RenderViolationsCell {...params} />
                ),
                }
            )
    }
}

export const  getColumnsOffenseWindows = (poles, values, setValues) => {
    
    let propsColumns = [];
    if (poles) {
        poles.map((el, index) => {
            const column = howColumn(el, values, setValues, poles[index].widthFieldXs)
            propsColumns.push(column)
         })
    }

    const columns = [...[
         { field: 'id', 
           headerName: 'id', 
           width: 100,
           editable: false,
         }   
       ], ...propsColumns];
    
    return columns

}


export const numberDateTime = (offenseWindow) => {
    const ListMap = [...offenseWindow]
    let list = []
    if (offenseWindow) {
        ListMap.map((el, index) => {
            if (   
                el.type === DynamicFields.DATE_TIME_SELECT ||
                el.type === DynamicFields.TABLE_DATE ||
                el.type === DynamicFields.TABLE_DATE_TIME ||
                el.type === DynamicFields.TABLE_TIME
            ) {
                list.push(el.variable)
            }
        }) 
    }
    return list
}